/** Family Plan V2 (CWS-1582): only car wash packages with a monthly membership can be family eligible. */
export function canBeFamilyEligible(
  packageType: string | null | undefined,
  washTypes: readonly string[] | null | undefined
): boolean {
  return (
    packageType === 'car_wash' &&
    Array.isArray(washTypes) &&
    washTypes.includes('monthly_membership')
  );
}

/**
 * Maps the modal's 'yes'/'no' radio to the API boolean; a package that cannot qualify is never eligible.
 * With the family plan flag off the toggle is hidden, so the form value is ignored: creates (incl.
 * duplicates) send false, and updates of a qualifying package send undefined to keep the stored value.
 */
export function buildFamilyEligible(
  formValue: string | null | undefined,
  packageType: string | null | undefined,
  washTypes: readonly string[] | null | undefined,
  context: { featureOn: boolean; isUpdate: boolean }
): boolean | undefined {
  const qualifies = canBeFamilyEligible(packageType, washTypes);
  if (!context.featureOn) {
    return context.isUpdate && qualifies ? undefined : false;
  }
  return formValue === 'yes' && qualifies;
}
